// extracted by mini-css-extract-plugin
module.exports = {"mobile-fixed-height":"Layout_style_mobile-fixed-height__qrYvs","mobile-header-logo-item":"Layout_style_mobile-header-logo-item__1FhSx"};